import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useCallback, useMemo } from 'react'; 
import { Button } from 'tea-component';
import { useHistory, useIntl } from 'umi';
import { goStatsDetailAction } from '../../stats/Detail';

export default function useFeedsDetail({ filter, channel, hasFeedsBtn }: any) {
  const { formatMessage } = useIntl();

  const history = useHistory();

  const gotoFeeds = useCallback(() => {
    goStatsDetailAction({
      path: `/opinion/Feeds/Feeds?tab=gameStore`,
      params: {
        statsDetailType: 'feeds-gameStoreLine',
        ...filter,
        channel: [channel],
        channel_type: 'comments',
      },
      history,
    });
  }, [channel, filter]);

  const feedsBtnElement = useMemo(() => {
    return (
      <Button
        className="to-feeds-detail-btn"
        type="primary"
        onClick={gotoFeeds}
      >
        {formatMessage({ id: 'Detailed feeds' })}
        <SvgIcon
          style={{
            height: 12,
            width: 12,
            marginLeft: 4,
            verticalAlign: 'middle',
          }}
          type="arrow-right"
        />
      </Button>
    );
  }, [formatMessage, gotoFeeds]);

  const operations = useMemo(() => {
    if (!hasFeedsBtn) {
      return [];
    }
    return [{ element: feedsBtnElement }];
  }, [feedsBtnElement]);

  return { operations, feedsBtnElement };
}
